import Subledger from './Subledger'

// Accounts payable subledger: what is owed to each vendor.
export default function APSubledger() {
  return <Subledger kind="ap" />
}
